/**
 * Carrier-specific EDI requirements.
 *
 * Some carriers (notably ARKAS) reject CODECO95B gate-OUT messages that
 * don't carry a real booking / service-order reference in the RFF+BN segment.
 * We use this list both to enforce the rule at form-submit time and to surface
 * a "Pending bookings" backlog on the EDI Messages page.
 */
export const CARRIERS_REQUIRING_BOOKING_ON_OUT = new Set([
  "ARK",   // ARKAS Line (rejects EDI without RFF+BN)
  "ARL",   // legacy ARKAS code
]);

/** Returns a human-readable error if the booking is missing for a
 *  carrier that requires one; otherwise null. */
export function validateBookingForOut(carrier, bookingNumber) {
  if (!carrier) return null;
  const cc = String(carrier).toUpperCase().trim();
  if (!CARRIERS_REQUIRING_BOOKING_ON_OUT.has(cc)) return null;
  if (bookingNumber && String(bookingNumber).trim()) return null;
  return `${cc} requires a Booking / Service-Order number on every gate-OUT before EDI can be transmitted.`;
}
